import * as React from "react";
const SvgFiBrandsDropbox = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M12 5.634 6 9.455l6 3.822-6 3.821-6-3.821 6-3.822-6-3.821 6-3.821zM5.982 18.366l6-3.821 6 3.821-6 3.821zM12 13.277l6-3.822-6-3.821 6-3.821 6 3.821-6 3.821 6 3.822-6 3.821z"
    />
  </svg>
);
export default SvgFiBrandsDropbox;
